<template>
    <Select v-bind="selectProp" :value="value&&selectProp.multiple?[...value]:value" @on-change="$emit('change',$event)">
        <Option v-for="(i,j) in dataList" :key="j" :value="Number(i[keys.value])">{{ i[keys.key] }}{{ extraKey?`(${i[extraKey]})`:'' }}</Option>
    </Select>
</template>

<script>
export default {
    props: {
        api: {
            type: Object,
            default: ()=>({
                url: '',
                pod: {}
            })
        },
        selectProp: {
            type: Object,
            default: ()=>({})
        },
        value: {
            type: String|Number|Array,
            default: ''
        },
        extraKey: {
            type: String,
            default: ''
        },
        keys: {
            type: Object,
            default: ()=>({
                key: 'label',
                value: 'id'
            })
        }
    },
    data(){
        return {
            dataList: []
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    methods: {
        getData(obj,data){
            if(this.api.url){
                return this.api.url({current:-1,size:-1,...this.api.pod,...obj}).then(r=>{
                    this.dataList = [...data,...r.data.records]
                    return r
                })
            }
            return Promise.resolve()
        }
    }
}
</script>